// eslint-disable-next-line no-unused-vars
import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import GenericPhotoUploader from 'Components/ComponentLibrary/Components/Uncategorized/PhotoUploader';

const PhotoUploaderPicker = ({ resource, ...rest }) => {
  return pickFunction(resource, {
    [fr.relationships.profileImage.name]: () => {
      return (
        <GenericPhotoUploader {...rest} resource={resource} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default PhotoUploaderPicker;
